<app-dialog [title]="data?.title" (close)="close()">
    <ng-container dialogHeader>
        <panel-tools
            [isPanelToolsDialog]="true"
            [showLangButton]="appService.languageCount > 1"
            (setCurrentLangForm)="setCurrentLangForm($event)">
        </panel-tools>
    </ng-container>
    <ng-container dialogContent>
        <div #formRef class="languages-dialog-form-container" [formGroup]="form"
             (keydown)="keyDownFunction($event)">
            <div *ngFor="let lang of appService.languages | keyvalue"
                 [class.!hidden]="lang?.value != currentLangForm">
                <ng-container dynamic-field [field]="{
                        type: 'input',
                        autoFocus: true,
                        label: appService.language_dictionary.system_field_name + (appService.languageCount > 1 ? '(' + lang?.value?.lang + ')' : ''),
                        inputType: 'text',
                        maxlength: '256',
                        name: lang?.value?.lang,
                        validations: [
                            {
                                name: 'required',
                                message: appService.language_dictionary.system_field_name_error
                            },
                            {
                                name: 'serverError'
                            }
                        ]
            }"
                              [group]="form.get('title')">
                </ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            (clickEvent)="save()"
            [label]="appService.language_dictionary.system_save"
            icon="content-save"
            height="mini">
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_close"
            icon="close"
            color="light"
            height="mini">
        </fui-button>
    </ng-container>
</app-dialog>
